// removed by extract-text-webpack-plugin
module.exports = {"wrap":"CwNotification-wrap","error":"CwNotification-error","informational":"CwNotification-informational","warning":"CwNotification-warning","successful":"CwNotification-successful","text":"CwNotification-text","icon":"CwNotification-icon","children":"CwNotification-children"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwnotification/CwNotification.scss
// module id = 374
// module chunks = 0